import { Container } from '@mui/material';
import { ExerciseReport } from 'components/templates';
import React from 'react';
import { useParams } from 'react-router-dom';

export const ExerciseReportView = () => {
  const { exerciseContentId: id } = useParams();
  return (
    <Container component="main" maxWidth="xl" sx={{ width: '75%' }}>
      <ExerciseReport id={id !== undefined ? Number(id) : 0} />
    </Container>
  );
};
